export type WeddingStage =
  | "inquiry"
  | "booked"
  | "planning"
  | "final_month"
  | "completed"
  | "archived";

/**
 * A single wedding engagement, scoped to an Organization. This is the
 * secondary tenant boundary: a planner may work across many weddings
 * inside one organization, and every future module (guests, budget,
 * timeline, run-of-show, vendors...) hangs off a weddingId.
 */
export interface Wedding {
  id: string;
  organizationId: string;
  coupleNames: string;
  partnerOneEmail?: string;
  partnerOnePhone?: string;
  partnerTwoEmail?: string;
  partnerTwoPhone?: string;
  weddingDate: string;
  venueName?: string;
  venueCity?: string;
  stage: WeddingStage;
  coverImageUrl?: string;
  guestCountEstimate?: number;
  budgetTotal?: number;
  createdAt: string;
  suspendedAt?: string;
  deletedAt?: string;
  purgeAfter?: string;
}

export const WEDDING_STAGE_LABELS: Record<WeddingStage, string> = {
  inquiry: "Inquiry",
  booked: "Booked",
  planning: "Planning",
  final_month: "Final month",
  completed: "Completed",
  archived: "Archived",
};

export const WEDDING_STAGES: WeddingStage[] = [
  "inquiry",
  "booked",
  "planning",
  "final_month",
  "completed",
  "archived",
];

/** Shape used by the create/edit wedding form — no id/organizationId/createdAt yet. */
export interface WeddingInput {
  coupleNames: string;
  partnerOneEmail?: string;
  partnerOnePhone?: string;
  partnerTwoEmail?: string;
  partnerTwoPhone?: string;
  weddingDate: string;
  venueName?: string;
  venueCity?: string;
  stage: WeddingStage;
  guestCountEstimate?: number;
  budgetTotal?: number;
}
